
import { Component, OnInit, Inject, Output, OnDestroy } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { CommonService, AlertService, AdminService } from '../../../_services/';
import { Subscription } from 'rxjs';


@Component({
  selector: 'app-edit-comment-type-dialog',
  templateUrl: './edit-comment-type-dialog.component.html',
  styleUrls: ['./edit-comment-type-dialog.component.scss']
})
export class EditCommentTypeDialogComponent implements OnInit {
  editCommentTypeForm:FormGroup;
  submitted = false;
  commentTypeData:any;
  errMsg:String = '';
  private subscription: Subscription;
  constructor(
    public dialogRef: MatDialogRef<EditCommentTypeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private _common : CommonService,
    private _alert : AlertService,
    private _admin:AdminService
  ) { }

  ngOnInit() {
    this.editCommentTypeForm = this.fb.group({
      id: [null, []],
      name: [null, [Validators.required,  Validators.minLength(3), Validators.maxLength(50)]]
    }) 
    this.getCommentTypeDetail(this.data.id);
  }


  hideEditCommentTypeDialog(){
    this.dialogRef.close();
  }


  get fval() {
    return this.editCommentTypeForm.controls;
  }

  getCommentTypeDetail(id){
    this._common.showLoader(true);
    this.subscription = this._admin.getCommentTypeDetail(id).subscribe(resp=>{
      this._common.showLoader(false);
      this.commentTypeData = resp;
      this.editCommentTypeForm.patchValue({ 
        id : this.commentTypeData.payload.data().id,
        name : this.commentTypeData.payload.data().name
      })
    },error=>{
      this._common.showLoader(false);
      this._alert.error('Something went wrong');
    })
  }

  onFormSubmit(){
    this.submitted = true;
    if (this.editCommentTypeForm.invalid) {
      return;
    } 
    let form = this.editCommentTypeForm.value;
    form.uid = localStorage.getItem('uid');
    form.record_type = 'user';
    this._common.showLoader(true);
    let data ={
      id : this.editCommentTypeForm.value.id,
      name : this.editCommentTypeForm.value.name
    }
    this._admin.editCommentType(data,this.data.id).then(res => {
      this._common.showLoader(false);
      this.dialogRef.close();
      this._alert.success("Comment type edited successfully!");
    },err=>{
      this._common.showLoader(false);
      this.errMsg = "Something went wrong"
    })   
  }

  ngOnDestroy(){
    if(this.subscription) this.subscription.unsubscribe();
  }


}



